import CurrentLiveVideoAsset from './CurrentLiveVideoAsset'
import CurrentPlayingAsset from './CurrentPlayingAsset'
import CurrentShowAsset from './CurrentShowAsset'

export default class NowPlayingAsset {
  constructor(obj) {
    // this.streamID = obj.stream_id;
    // this.streamType = obj.stream_type;
    // this.stationID = obj.station_id;
    this.service = obj.service
    this.currentShow = new CurrentShowAsset(obj.current_show)
    this.currentPlaying = new CurrentPlayingAsset(obj.now_playing)
    this.liveVideo = new CurrentLiveVideoAsset(obj.go_live)

    // this.prevPlayed = obj.previously_played;
    // this.upNext = obj.up_next;
  }
}
